import { render } from "./MenuContent.vue?vue&type=template&id=44ff61c6&ts=true"
import script from "./MenuContent.vue?vue&type=script&lang=ts"
export * from "./MenuContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__